import { DashboardCardLinkButton } from '../../storageDashboard/DashboardCardLinkButton';
import type { PatientTrackingDashboardSummary } from './patientTrackingDashboardTypes';
import { formatDashboardTimestamp } from './patientTrackingDashboardFormatters';

interface PharmacyCeOverviewCardProps {
  summary: PatientTrackingDashboardSummary;
  openHref: string;
}

export function PharmacyCeOverviewCard({ summary, openHref }: PharmacyCeOverviewCardProps) {
  const lastAlert = summary.lastAlertRun;

  return (
    <section className="dashboard-card dashboard-card--pharmacy-ce">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Covered Entities</h3>
          <p>CE activity and daily alerting snapshot</p>
        </div>
        <DashboardCardLinkButton text="Open CE List" href={openHref} />
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.activeCeCount}</span>
          <span className="dashboard-kpi__label">Active CEs</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.totalCeCount}</span>
          <span className="dashboard-kpi__label">Total CEs</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.closedIssueCount}</span>
          <span className="dashboard-kpi__label">Closed issues</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Top CEs by Open Issues</h4>
        {summary.topCesByOpenIssues.length === 0 ? (
          <p className="dashboard-empty">No open issues across covered entities.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.topCesByOpenIssues.map((ce) => (
              <li key={ce.id}>
                <span>
                  <strong>{ce.coveredEntityName}</strong>
                </span>
                <span>{ce.openIssueCount}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {lastAlert ? (
        <div className="dashboard-type-row" aria-label="Last daily alert run">
          <span className="dashboard-pill">
            Last alert: {lastAlert.result} · {formatDashboardTimestamp(lastAlert.sentDate)}
          </span>
          <span className="dashboard-pill">CEs alerted: {lastAlert.ceAlerted}</span>
          <span className="dashboard-pill">Emails sent: {lastAlert.emailsSent}</span>
          {lastAlert.errors > 0 ? (
            <span className="dashboard-pill">Errors: {lastAlert.errors}</span>
          ) : null}
        </div>
      ) : (
        <p className="dashboard-empty">No alerting history recorded yet.</p>
      )}
    </section>
  );
}
